import { CallAPI } from "../../apiManager/ApiCall";
import { communityAdsURL } from "apiManager/APIConfig";

export const GetCommunityAdsCall = async (page = 1, limit = 10) => {
  try {
    const params = new URLSearchParams();
    if (page) params.append("page", String(page));
    if (limit) params.append("limit", String(limit));

    const response = await CallAPI({
      url: `${communityAdsURL}?${params.toString()}`,
      method: "GET",
    });

    if (response?.status === 200 && Array.isArray(response?.ads)) {
      return {
        ads: response.ads,
        total: Number(response.total) || 0,
        page: Number(response.page) || page,
        limit: Number(response.limit) || limit,
        totalPages: Number(response.totalPages) || 1,
      };
    }
    return { ads: [], total: 0, page, limit, totalPages: 1 };
  } catch (error) {
    return { ads: [], total: 0, page, limit, totalPages: 1 };
  }
};

export const AddCommunityAdCall = async (payload, setProgress) => {
  try {
    const formData = new FormData();
    if (payload?.title) formData.append("title", payload.title);
    if (payload?.description) formData.append("description", payload.description);
    if (payload?.cta_type) formData.append("cta_type", payload.cta_type);
    if (payload?.cta_value) formData.append("cta_value", payload.cta_value);
    if (payload?.start_at) formData.append("start_at", payload.start_at);
    if (payload?.end_at) formData.append("end_at", payload.end_at);
    if (payload?.videoFile) formData.append("video", payload.videoFile);
    if (payload?.thumbnailFile) formData.append("thumbnail", payload.thumbnailFile);

    const response = await CallAPI({
      url: communityAdsURL,
      method: "POST",
      formData,
      setProgress: setProgress || (() => {}),
    });
    return response;
  } catch (error) {
    return { status: 400, message: "Failed to upload community ad" };
  }
};

export const DeleteCommunityAdCall = async (adId) => {
  if (!adId) return { status: 400, message: "adId is required" };
  try {
    const response = await CallAPI({
      url: `${communityAdsURL}/${adId}`,
      method: "DELETE",
    });
    return response;
  } catch (error) {
    return { status: 400, message: "Failed to delete community ad" };
  }
};

